/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCustomCssPresetDto } from '../../models/create-custom-css-preset-dto';
import { CustomCssPresetDto } from '../../models/custom-css-preset-dto';

export interface CustomCssControllerCreate$Params {
  storeId: string;

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
      body: Array<CreateCustomCssPresetDto>
}

export function customCssControllerCreate(http: HttpClient, rootUrl: string, params: CustomCssControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomCssPresetDto>>> {
  const rb = new RequestBuilder(rootUrl, customCssControllerCreate.PATH, 'post');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomCssPresetDto>>;
    })
  );
}

customCssControllerCreate.PATH = '/api/v1/stores/{storeId}/custom-css';
